/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyContactListCountrySerializer
 */
export interface ReadOnlyContactListCountrySerializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyContactListCountrySerializer
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyContactListCountrySerializer
     */
    iso2?: string;
}

export function ReadOnlyContactListCountrySerializerFromJSON(json: any): ReadOnlyContactListCountrySerializer {
    return ReadOnlyContactListCountrySerializerFromJSONTyped(json, false);
}

export function ReadOnlyContactListCountrySerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyContactListCountrySerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'iso2': !exists(json, 'iso2') ? undefined : json['iso2'],
    };
}

export function ReadOnlyContactListCountrySerializerToJSON(value?: ReadOnlyContactListCountrySerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'iso2': value.iso2,
    };
}


